var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAbout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.779 4.222a10.967 10.967 0 0 0-9.545-3.084A11.077 11.077 0 0 0 1.2 9.925a10.958 10.958 0 0 0 .852 6.742L1.441 19.7A2.432 2.432 0 0 0 4.3 22.559l3.029-.606A10.911 10.911 0 0 0 12 23a11.252 11.252 0 0 0 2.076-.194 11.08 11.08 0 0 0 8.788-9.041 10.96 10.96 0 0 0-3.085-9.543zm1.107 9.235a8.989 8.989 0 0 1-12.963 6.559.991.991 0 0 0-.454-.11 1.013 1.013 0 0 0-.2.02l-3.36.672a.434.434 0 0 1-.51-.51l.672-3.361a.994.994 0 0 0-.09-.65 8.991 8.991 0 0 1 6.562-12.963 9.012 9.012 0 0 1 10.343 10.343z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 15v-4a1 1 0 0 0-1-1h-1a1 1 0 0 0 0 2v4a1 1 0 0 0 1 1h1a1 1 0 0 0 0-2z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 8,
    r: 1,
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout);
export default __webpack_public_path__ + "static/media/about.26e475f391be03eff9a29fb8593a2b77.svg";
export { ForwardRef as ReactComponent };